import React, { useState } from "react";
import { exportToExcel } from "../../utils/ExcelUtils";
import { getExportSimSwapData } from "../../actions/SimSwapAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSession } from "../layout/SessionContext";
import { formatDate, formatDateOnly } from "../../utils/DateFormat";

const columns = [
  { key: "uid", label: "ID" },
  { key: "oldMobileNumber", label: "Customer old number" },
  { key: "customerFirstName", label: "First name" },
  { key: "customerLastName", label: "Last name" },
  { key: "dateOfBirth", label: "Date of Birth" },
  { key: "pukCode", label: "PUK Code " },
  { key: "newSimSerialNumber", label: "New Sim Serial Number" },
  { key: "createdAt", label: "Date & Time" },
  { key: "status", label: "Status", isStatus: true },
  { key: "note", label: "Note" },
];

const Header = ({ filters, searchTerm }) => {
  const [loading, setLoading] = useState(false);
  const { hasPermission } = useSession();
  const headerMap = {};
  columns.forEach((col) => {
    headerMap[col.key.replace(/\./g, "_")] = col.label;
  });

  const getSimSwapData = async () => {
    setLoading(true);
    try {
      const response = await getExportSimSwapData(filters, searchTerm);
      if (response.success) {
        const formattedData = response.data.map((item) => ({
          ...item,
          dateOfBirth: formatDateOnly(item.dateOfBirth) || "N/A",
          createdAt: formatDate(item.createdAt) || "N/A",
        }));

        exportToExcel(formattedData, "SimSwap", "SimSwap", headerMap);
      } else {
        toast.error(response?.message || "Failed to export SimSwap data");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 sm:px-10">
      <div className="flex flex-row justify-between items-center gap-4">
        <h1 className="font-bold text-text1 whitespace-nowrap text-[24px] sm:text-[26px] md:text-[30px]">Sim Swap</h1>
        {hasPermission("Sim swap", "export") && (
          <button
            className="secondary_button text-xs sm:text-sm h-8 sm:h-10 px-3 sm:px-4 flex items-center justify-center"
            onClick={getSimSwapData}
            disabled={loading}
          >
            {loading ? "Loading..." : "Export Excel"}
          </button>
        )}
      </div>
      <hr className="border-gray-300 mt-6" />
    </div>
  );
};

export default Header;
